import React from 'react';
import {useTranslation} from 'react-i18next';
import PhoneCall from '../../../../assets/icons/PhoneCall';
import EmailContact from '../../../../assets/icons/EmailContact';
import {Whatsapp} from '../../../../assets/icons/Whatsapp';
import {formatPhoneDisplay} from '../../../../library/formatPhone';
import LinkSheet, {SheetLink} from '../LinkSheet/LinkSheet';
import {TShow} from '../../../../hooks/useShow';
import {TEticketData} from '../../../../redux/eTicket/eTicket.type';

interface ContactSheetProps {
    show: TShow;
    data: TEticketData | null;
}

function ContactSheet({show, data}: ContactSheetProps): React.ReactElement | null {
    const {t} = useTranslation('eTicket');
    const phone = data?.producer?.phone || data?.order?.phone;
    const email = data?.producer?.email || data?.order?.email;
    if(!phone && !email) return null;

    const digits = String(phone || '').replace(/\D/g, '');
    const isMobile = /^(?:972|0)5\d{8}$/.test(digits);

    const links: SheetLink[] = [];
    if(phone)
        links.push({key: 'call', label: t('contactCall'), value: formatPhoneDisplay(phone), href: `tel:${phone}`, icon: <PhoneCall size={22} />});
    if(email)
        links.push({key: 'email', label: t('contactEmail'), value: email, href: `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(email)}`, icon: <EmailContact size={22} />, external: true});
    if(isMobile)
        links.push({key: 'whatsapp', label: t('contactWhatsapp'), value: phone, href: `https://wa.me/${digits.replace(/^0/, '972')}`, icon: <Whatsapp width={22} height={22} />, external: true});

    return <LinkSheet show={show} title={t('contactTitle')} links={links} showArrow data-cy="ticket-fab-contact-sheet" />;
}

export default ContactSheet;
